import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {MODIFIERS_TYPES_LIST} from "../../../enums/e-modifiers";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-influence-sender",
    templateUrl: "./go-influence-sender.component.html"
})


export class GoInfluenceSenderComponent extends GoBaseComponent {
  UI_TEXTS = UI_TEXTS;
    MODIFICATORS_LIST = MODIFIERS_TYPES_LIST;


    constructor() {
        super(GO_COMPONENTS.INFLUENCE_SENDER);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-influence/go-influence-sender.component.ts